import {
    SET_RECEIPT_SETTINGS_DATA_LOADING,
    SET_RECEIPT_SETTINGS_DATA,
    CLEAR_RECEIPT_SETTINGS_DATA,
} from "../actions/types";

const initialState = {
    isLoading: false,
    receiptSettingsData: [],
};

export default function (state = initialState, action) {
    const { type, payload } = action;
    switch (type) {
        case SET_RECEIPT_SETTINGS_DATA_LOADING:
            return {
                ...state,
                isLoading: payload,
            };
        case SET_RECEIPT_SETTINGS_DATA:
            return {
                ...state,
                receiptSettingsData: Array.isArray(payload) ? [...payload] : [],
                isLoading: false,
            };
        default:
            return state;
    }
}
